import * as React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import theme from "../../../theme";

export const ContentTestIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        {...props}
        viewBox="0 0 45 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="45"
          height="41.4935"
          rx="6"
          fill={props.fill ?? theme.palette.primary.main}
        />
        <path
          d="M6.615 20.085C6.38833 20.085 6.20133 20.0113 6.054 19.864C5.918 19.7167 5.85 19.5353 5.85 19.32C5.85 19.2293 5.87833 19.116 5.935 18.98L10.27 8.746C10.3607 8.542 10.4853 8.37767 10.644 8.253C10.814 8.117 11.018 8.049 11.256 8.049H11.426C11.664 8.049 11.8623 8.117 12.021 8.253C12.191 8.37767 12.3213 8.542 12.412 8.746L16.747 18.98C16.8037 19.116 16.832 19.2293 16.832 19.32C16.832 19.5353 16.7583 19.7167 16.611 19.864C16.475 20.0113 16.2937 20.085 16.067 20.085C15.9083 20.085 15.761 20.0453 15.625 19.966C15.5003 19.8753 15.404 19.7563 15.336 19.609L14.231 16.957H8.451L7.346 19.609C7.278 19.7563 7.176 19.8753 7.04 19.966C6.91533 20.0453 6.77367 20.085 6.615 20.085ZM9.046 15.546H13.636L11.341 10.021L9.046 15.546Z"
          fill="white"
        />
        <path
          d="M29.414 20C29.1987 20 29.0173 19.9263 28.87 19.779C28.7227 19.6317 28.649 19.4503 28.649 19.235V8.916C28.649 8.70067 28.7227 8.51933 28.87 8.372C29.0173 8.21333 29.1987 8.134 29.414 8.134H33.426C34.6387 8.134 35.5737 8.41167 36.231 8.967C36.8997 9.52233 37.234 10.2703 37.234 11.211C37.234 11.8683 37.0753 12.418 36.758 12.86C36.452 13.2907 36.0553 13.6137 35.568 13.829C36.248 14.0443 36.8033 14.39 37.234 14.866C37.676 15.342 37.897 15.9427 37.897 16.668C37.897 17.7107 37.5457 18.5267 36.843 19.116C36.1403 19.7053 35.0353 20 33.528 20H29.414ZM33.018 13.268C34.0267 13.268 34.735 13.098 35.143 12.758C35.551 12.418 35.755 11.942 35.755 11.33C35.755 10.7973 35.534 10.3723 35.092 10.055C34.6613 9.73767 34.0663 9.579 33.307 9.579H30.196V13.268H33.018ZM33.375 18.555C34.4743 18.555 35.2507 18.385 35.704 18.045C36.1687 17.705 36.401 17.2233 36.401 16.6C36.401 15.308 35.398 14.662 33.392 14.662H30.196V18.555H33.375Z"
          fill="white"
        />
        <line
          x1="5.75"
          y1="24.7957"
          x2="17.1071"
          y2="24.7957"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="27.75"
          y1="24.7957"
          x2="39.1071"
          y2="24.7957"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="5.75"
          y1="28.8865"
          x2="17.1071"
          y2="28.8865"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="27.75"
          y1="28.8865"
          x2="39.1071"
          y2="28.8865"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="5.75"
          y1="32.9773"
          x2="17.1071"
          y2="32.9773"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="27.75"
          y1="32.9773"
          x2="39.1071"
          y2="32.9773"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="22.707"
          y1="6.92871"
          x2="22.707"
          y2="35.7339"
          stroke="white"
          strokeLinecap="round"
        />
      </svg>
    </SvgIcon>
  );
};
